const API_BASE_URL = 'http://localhost:5000/api';

export const api = {
    // Get all politicians
    getAllPoliticians: async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/politicians/all`);
            if (!response.ok) throw new Error('Failed to fetch politicians');
            return await response.json();
        } catch (error) {
            console.error('Error fetching all politicians:', error);
            return [];
        }
    },

    // Get politicians by branch
    getPoliticiansByBranch: async (branch) => {
        try {
            const response = await fetch(`${API_BASE_URL}/politicians/${branch}`);
            if (!response.ok) throw new Error(`Failed to fetch ${branch} politicians`);
            return await response.json();
        } catch (error) {
            console.error(`Error fetching ${branch} politicians:`, error);
            return [];
        }
    },

    // Get single politician
    getPolitician: async (id) => {
        try {
            const response = await fetch(`${API_BASE_URL}/politicians/${id}`);
            if (!response.ok) throw new Error('Failed to fetch politician');
            return await response.json();
        } catch (error) {
            console.error('Error fetching politician:', error);
            return null;
        }
    },

    // Get unhealthiest politicians
    getUnhealthiestPoliticians: async (count = 10) => {
        try {
            const response = await fetch(`${API_BASE_URL}/politicians/unhealthiest/${count}`);
            if (!response.ok) throw new Error('Failed to fetch unhealthiest politicians');
            return await response.json();
        } catch (error) {
            console.error('Error fetching unhealthiest politicians:', error);
            return [];
        }
    },

    // Get health details for a politician
    getHealthDetails: async (id) => {
        try {
            const response = await fetch(`${API_BASE_URL}/health/${id}`);
            if (!response.ok) throw new Error('Failed to fetch health details');
            return await response.json();
        } catch (error) {
            console.error('Error fetching health details:', error);
            return null;
        }
    },

    // Get all politicians with critical health
    getCriticalHealthPoliticians: async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/health/critical/all`);
            if (!response.ok) throw new Error('Failed to fetch critical health politicians');
            return await response.json();
        } catch (error) {
            console.error('Error fetching critical health politicians:', error);
            return [];
        }
    }
};